import D2C_HostCloud from './Cloud'

class D2C_HostAWS extends D2C_HostCloud {
  static objectType = 'hostType'
  static active = true
  static providerType = 'AWS'
  static color = '#ff9900'
  static minExtraStorage = 10
  static maxExtraStorage = 16000
  static stats = {
    ...D2C_HostCloud,
    ebs_disk: {},
  }
  static fields = {
    ...D2C_HostCloud.fields,
    extraStorage: {
      default: 0,
      infoHeader: 'Elastic Block Store (EBS)',
      infoLine1: 'Additional storage for instances by Amazon.',
      infoLine2: 'You don\'t have to restart the host when you change it.',
      label: 'Size',
      path: 'extraStorage',
      required: false,
      width: 4,
      validate(value) {
        return value && value < 10 ? 'Must be more than 10' : null
      },
      updating: {},
    },
    instance: {
      ...D2C_HostCloud.fields.instance,
      reversible: true,
      reversibleReadonly: true,
    },
  }
}

export default D2C_HostAWS
